type ChatConversation = {
  title: string;
  createdAt: string;
  updatedAt: string;
};

const chatConversation: ChatConversation = {
  title: "",
  createdAt: "",
  updatedAt: "",
};

export type { ChatConversation };

export { chatConversation };
